module.exports = __webpack_public_path__ + "static/media/Sketch13.a906ea78.jpg";